import { Component } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SingleDetailComponent } from 'app/shared/components/single-detail/single-detail.component';
import { IWineBottleSummary } from 'app/shared/models/wine-bottles.models';
import { BottleService } from 'app/shared/services/bottle.service';

import { ScannedDetailsComponentBase } from '../ScannedDetailsComponentBase';

@Component({
  selector: 'app-scanned-bottle-details',
  templateUrl: './scanned-bottle-details.component.html',
  styleUrls: ['./scanned-bottle-details.component.css'],
  standalone: true,
  imports: [SingleDetailComponent],
})
export class ScannedBottleDetailsComponent extends ScannedDetailsComponentBase {
  public wineBottleDetails: IWineBottleSummary;

  constructor(private bottleService: BottleService) {
    super();
  }

  handleCodeScanned(): void {
    this.bottleService
      .getBottleSummaryByLabelCodeV1(this.labelCode.identifier)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (wineBottleDetails: IWineBottleSummary) => {
          this.wineBottleDetails = wineBottleDetails;
          this.navigationInstructions.emit(['/bottles', wineBottleDetails.id]);
        },
        error: (_error) => this.handleScanFail(),
      });
  }
}
